import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import R from 'ramda';

import styles from './submit.css';

const { button } = hh(h);

const Submit = ({
    size = 'medium',
    theme = 'default'
}) => button(
    {
        type: 'submit',
        className: classNames(
            styles.button,
            R.prop(size, styles),
            R.prop(theme, styles)
        )
    },
    'Submit');

Submit.propTypes = {
    size: PropTypes.oneOf(['medium']),
    theme: PropTypes.oneOf(['default'])
};

export default Submit;



/** WEBPACK FOOTER **
 ** ./src/Submit/index.js
 **/